import plaqueSmallBadImg from '../content/plaque_small_bad.png';
import './PlaqueSmallBad.css';

/** From Figma plaque_small_bad (142:17543) → 226.20 446. */
export function PlaqueSmallBad() {
  return (
    <img
      className="fail-delivery-plaque-small-bad"
      src={plaqueSmallBadImg}
      alt="Ты угодил в препятствие и не смог выбраться"
      draggable={false}
    />
  );
}
